/**
 * Full-screen loading state shown while Keycloak initializes, passed to
 * AuthProvider as its `loadingFallback` so the app shows a signing-in indicator
 * instead of a blank page during the redirect handshake.
 */
export function AuthLoading(): React.JSX.Element {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-background text-foreground"
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-3">
        <div
          className="size-8 animate-spin rounded-full border-2 border-muted border-t-primary"
          aria-hidden
        />
        <p className="text-sm text-muted-foreground">Signing you in…</p>
      </div>
    </div>
  );
}
